import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import {
    primaryMailboxSearchScope,
    archiveMailboxSearchScope,
    SearchScope,
    SearchScopeKind,
} from 'owa-search-service';
import {
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
    PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID,
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
    ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID,
    getMailRootFolderChildIds,
} from 'owa-folders';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getPrimaryMailboxSearchScopeList(): SearchScope[] {
    const searchScopes: SearchScope[] = [];

    // Add some distinguished folders and a root folder
    searchScopes.push(
        primaryMailboxSearchScope({
            folderId: folderNameToId(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID),
            kind: SearchScopeKind.PrimaryMailbox,
        })
    );

    if (isFeatureEnabled('sea-advanced-search')) {
        const folderIds = getMailRootFolderChildIds('primary');

        for (let folderId of folderIds) {
            searchScopes.push(
                primaryMailboxSearchScope({
                    folderId: folderId,
                    kind: SearchScopeKind.PrimaryMailbox,
                })
            );
        }
    } else {
        searchScopes.push(
            primaryMailboxSearchScope({
                folderId: folderNameToId('inbox'),
                kind: SearchScopeKind.PrimaryMailbox,
            })
        );
        searchScopes.push(
            primaryMailboxSearchScope({
                folderId: folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID),
                kind: SearchScopeKind.PrimaryMailbox,
            })
        );
        searchScopes.push(
            primaryMailboxSearchScope({
                folderId: folderNameToId('sentitems'),
                kind: SearchScopeKind.PrimaryMailbox,
            })
        );

        // Add the primary mailbox archive folder if user has one set
        const archiveFolderId = getUserConfiguration().UserOptions.ArchiveFolderId;
        if (archiveFolderId) {
            searchScopes.push(
                primaryMailboxSearchScope({
                    folderId: archiveFolderId,
                    kind: SearchScopeKind.PrimaryMailbox,
                })
            );
        }
    }

    return searchScopes;
}

export function getArchiveMailboxSearchScopeList(): SearchScope[] {
    const searchScopes: SearchScope[] = [];
    // Add some distinguished folders and archive root folder
    searchScopes.push(
        archiveMailboxSearchScope({
            folderId: folderNameToId(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID),
            kind: SearchScopeKind.ArchiveMailbox,
        })
    );
    searchScopes.push(
        archiveMailboxSearchScope({
            folderId: folderNameToId(ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID),
            kind: SearchScopeKind.ArchiveMailbox,
        })
    );
    return searchScopes;
}

export function getSharedFoldersScopeList(): SearchScope[] {
    return [];
}

export function getGroupSearchScopeList(): SearchScope[] {
    return [];
}

export function getCalendarSearchScopeList(): SearchScope[] {
    return [];
}
